import React, { useState, useCallback } from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import { RiCloseLine } from 'react-icons/ri';

import api from '../../../../../../../../services/api';
import { useToast } from '../../../../../../../../hooks/toast';
import { useRegisterAdded } from '../../../../../../../../hooks/registerAdded';

import { ModalWrapper, MenuOptionButton } from '../../../../../styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      width: '70%',
      backgroundColor: theme.palette.background.paper,
      border: '1px solid #757575',
      borderRadius: '6px',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 0, 3),
    },
  }),
);

interface DeleteComplementoProps {
  id_complemento: number;
  title_complemento: string;
}

const DeleteComplementoOption: React.FC<DeleteComplementoProps> = ({
  id_complemento,
  title_complemento,
}) => {
  const [open, setOpen] = useState(false);
  const [btnDisable, setBtnDisable] = useState(false);

  const classes = useStyles();

  const { addToast } = useToast();
  const { handleSetComplementoUpdated } = useRegisterAdded();

  const handleOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  const handleDeleteComplemento = useCallback(async () => {
    try {
      setBtnDisable(true);
      const response = await api.post(`/complemento/${id_complemento}`);

      handleSetComplementoUpdated(true);
      addToast({
        type: 'success',
        title: response.data.message,
      });

      setOpen(false);
      setBtnDisable(false);
    } catch (err) {
      const { message } = err.response.data;

      addToast({
        type: 'error',
        title: message,
      });
      setBtnDisable(false);
    }
  }, [id_complemento, addToast, handleSetComplementoUpdated]);

  return (
    <div>
      <MenuOptionButton type="button" onClick={handleOpen}>
        Excluir
      </MenuOptionButton>

      <Modal
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <ModalWrapper>
            <div className="header">
              <h1>Atenção</h1>

              <button type="button" onClick={handleClose}>
                <RiCloseLine size={30} />
              </button>
            </div>

            <div className="description">
              <span>Deseja excluir o complemento {title_complemento}?</span>
            </div>

            <div className="btnActions">
              <button
                type="button"
                className="confirm"
                onClick={handleDeleteComplemento}
                disabled={btnDisable}
              >
                Confirmar
              </button>

              <button type="button" className="cancel" onClick={handleClose}>
                Cancelar
              </button>
            </div>
          </ModalWrapper>
        </Fade>
      </Modal>
    </div>
  );
};

export default DeleteComplementoOption;
